import React, { useRef, useState } from 'react';
import { Button, Container, Card } from 'shards-react';
import {
  Row,
  Col,
  Form,
  FormGroup,
  InputGroup,
  CardBody,
  FormInput
} from 'shards-react';
import PageTitle from '../components/common/PageTitle';
import { API_URL, BARCODE_RESPONSE_HEIGHT, BARCODE_RESPONSE_WIDTH, BARCODE_WIDTH, getBarcodeImageHeight, getBarcodeValuesFromResponse } from '../config/index';
import ReactDatatable from '@ashvin27/react-datatable';
import Loader from 'react-loader-spinner';
import Modal from 'react-bootstrap/Modal';
import writtenNumber from 'written-number';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import moment from 'moment';
import { strings } from '../localization';

export const UserStatus = React.forwardRef((props, ref) => {
  const [isButtonChecked, setIsButtonChecked] = React.useState(false);
  const [isButtonClosed, setIsButtonClosed] = React.useState(false);

  React.useImperativeHandle(
    ref,
    () => ({
      userStatusList: () => {
        if (isButtonChecked) {
          return { _id: props.record._id, userStatus: 'ACCEPT' };
        } else if (isButtonClosed) {
          return { _id: props.record._id, userStatus: 'REJECT' };
        } else {
          return { _id: props.record._id, userStatus: 'PENDING' };
        }
      }
    }),
    [isButtonChecked, isButtonClosed]
  );

  return (
    <div className="d-flex flex-direction-row">
      <div
        onClick={() => {
          setIsButtonClosed(false);
          if (isButtonChecked) {
            setIsButtonChecked(false);
          } else {
            setIsButtonChecked(true);
          }
        }}
        style={{
          height: 25,
          width: 50,
          backgroundColor: isButtonChecked ? '#00e676' : '#fff',
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
          boxShadow: '5px 10px 18px #888888'
        }}
      >
        <i class="material-icons" style={{ fontSize: 20 }}>
          done
        </i>
      </div>
      <div
        onClick={() => {
          setIsButtonChecked(false);
          if (isButtonClosed) {
            setIsButtonClosed(false);
          } else {
            setIsButtonClosed(true);
          }
        }}
        style={{
          height: 25,
          width: 50,
          backgroundColor: isButtonClosed ? '#ff1744' : '#fff',
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
          boxShadow: '5px 10px 18px #888888',
          borderLeft: '1px solid black'
        }}
      >
        <i class="material-icons" style={{ fontSize: 20 }}>
          close
        </i>
      </div>
    </div>
  );
});
function ConfirmationModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Confirmation
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Summary:</p>
        <p style={{ marginLeft: 15 }}>{props.accepted} Accepted Documents</p>
        <p style={{ marginLeft: 15 }}>{props.rejected} Rejected Documents</p>
        <p style={{ marginTop: 20 }}>Are you sure you want to proceed?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} style={{ width: '10%' }}>
          No
        </Button>

        <Button
          style={{ width: '10%' }}
          onClick={() => {
            props.onConfirmation();
          }}
        >
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
function DocumentDetailsModal(props) {
  // const { barcodeImage, barcodeHeight, barcodeWidth } = props;
  console.log('props in details modal', props);
  const [tipoDocValues, setTipoDocValues] = useState([
    {
      tipoDoc: '30',
      value: 'Factura'
    },
    {
      tipoDoc: '33',
      value: 'Factura'
    },
    {
      tipoDoc: '34',
      value: 'Factura NO AFECTA O EXENTA'
    },
    {
      tipoDoc: '39',
      value: 'BOLETA'
    },
    {
      tipoDoc: '41',
      value: 'BOLETA NO AFECTA O EXENTA'
    },
    {
      tipoDoc: '52',
      value: 'GUIA DE DESPACHO'
    },
    {
      tipoDoc: '56',
      value: 'NOTA DE DÉBITO'
    },
    {
      tipoDoc: '61',
      value: 'NOTA DE CRÉDITO'
    }
  ]);
  //    let itemData = {"_id":"631f2d53841381d72f6bbc29","data":{"encoding":"ISO-8859-1","document":{"@ID":"F12165273T33","Encabezado":{"IdDoc":{"TipoDTE":"33","Folio":"12165273","FchEmis":"2022-09-12","FmaPago":"1","FchVenc":"2022-09-12"},"Emisor":{"RUTEmisor":"91806000-6","RznSoc":"Abastible S.A.","GiroEmis":"Distribucion y transporte de combustibles, instalaciones de gas licuado","Acteco":"402000","Sucursal":"PLANTA TALCA","CdgSIISucur":"10489077","DirOrigen":"Camino Longitudinal Km. 255","CmnaOrigen":"Talca","CiudadOrigen":"TALCA","CdgVendedor":"916"},"Receptor":{"RUTRecep":"6492827-9","CdgIntRecep":"0010546793","RznSocRecep":"IRIS DEL CARMEN FIGUEROA FIGUEROA","GiroRecep":"VTA MEN GAS LIC BOM","Contacto":"dayanna_medina@hotmail.com","DirRecep":"HUAMACHUCO S/N","CmnaRecep":"SAN CLEMENTE"},"Transporte":{"RUTTrans":"6035602-5","DirDest":"HUAMACHUCO S/N","CmnaDest":"SAN CLEMENTE"},"Totales":{"MntNeto":"4693908","MntExe":"0","TasaIVA":"19.00","IVA":"891842","ImptoReten":{"TipoImp":"14","TasaImp":"19","MontoImp":"59874"},"MntTotal":"5645624","SaldoAnterior":"0","VlrPagar":"5645624"}},"Detalle":{"NroLinDet":"1","CdgItem":{"TpoCodigo":"INT1","VlrCodigo":"GAS15N"},"NmbItem":"UN Carga de gas 15 kg Normal","QtyItem":"250.000000","PrcItem":"23619.328000","CodImpAdic":"14","MontoItem":"5904832"},"DscRcgGlobal":[{"NroLinDR":"1","TpoMov":"D","TpoValor":"$","ValorDR":"315126.00"},{"NroLinDR":"2","TpoMov":"D","TpoValor":"$","ValorDR":"115546.00"},{"NroLinDR":"3","TpoMov":"D","TpoValor":"$","ValorDR":"31513.00"},{"NroLinDR":"4","TpoMov":"D","TpoValor":"$","ValorDR":"672269.00"},{"NroLinDR":"5","TpoMov":"D","TpoValor":"$","ValorDR":"76471.00"}],"TED":{"@version":"1.0","DD":{"RE":"91806000-6","TD":"33","F":"12165273","FE":"2022-09-12","RR":"6492827-9","RSR":"IRIS DEL CARMEN FIGUEROA FIGUEROA","MNT":"5645624","IT1":"UN Carga de gas 15 kg Normal","CAF":{"@version":"1.0","DA":{"RE":"91806000-6","RS":"ABASTIBLE S.A.","TD":"33","RNG":{"D":"12150280","H":"12200279"},"FA":"2022-05-26","RSAPK":{"M":"1E7NY9AH3ESB1gCkbsJ4A/uOi7/OJbUJF+SCEsftn/+YhvXQhQuni5L3vpJM0UtDe1CLZR3PB8SIrGn4y4jzCw==","E":"Aw=="},"IDK":"300"},"FRMA":{"@algoritmo":"SHA1withRSA","#text":"eV5Tg2UvSceDsvLxnowMXEPc7SU1+ttbB819pxFcRhSOxAxbQhnauQlIO98xMThh2s2WkhvZWxS/GxD/2sXheQ=="}},"TSTED":"2022-09-12T09:49:48"},"FRMT":{"@algoritmo":"SHA1withRSA","#text":"HznqfxrPE8NksjtEpoqKLWIEOPqftrW01Waap2hJmrml6meSktR/HCi5ODKGd7ja7s2rQ+zA5U+l5NyaxbOKog=="}},"TmstFirma":"2022-09-12T09:50:27"},"tipoDTE":"33","folio":"12165273","userStatus":"ACCEPTED","xmlGenerated":true,"autoApproved":true,"archived":false,"organisationID":"61f73517f61ed6ab6c8c3833"},"log":{"created_at":"2022-09-12T10:00:03.563000","created_by":"5fd1e1bb79c3e400079851fa","auto_approved_at":"2022-09-20T11:00:02.377000"}}
  //    itemData = {"_id":"6321ec76896138d392ef0974","data":{"encoding":"ISO-8859-1","document":{"@ID":"F2933959T52","Encabezado":{"IdDoc":{"TipoDTE":"52","Folio":"2933959","FchEmis":"2022-09-14","TipoDespacho":"3","IndTraslado":"6"},"Emisor":{"RUTEmisor":"91806000-6","RznSoc":"Abastible S.A.","GiroEmis":"Distribucion y transporte de combustibles, instalaciones de gas licuado","Acteco":"402000","Sucursal":"PLANTA TALCA","CdgSIISucur":"10489077","DirOrigen":"Camino Longitudinal Km. 255","CmnaOrigen":"Talca","CiudadOrigen":"TALCA","CdgVendedor":"916"},"Receptor":{"RUTRecep":"6492827-9","CdgIntRecep":"0301750230","RznSocRecep":"IRIS DEL CARMEN FIGUEROA FIGUEROA","GiroRecep":"VTA MEN GAS LIC BOM","Contacto":"dayanna_medina@hotmail.com","DirRecep":"HUAMACHUCO S/N","CmnaRecep":"SAN CLEMENTE"},"Transporte":{"RUTTrans":"6035602-5","DirDest":"HUAMACHUCO S/N","CmnaDest":"SAN CLEMENTE"},"Totales":{"MntTotal":"1"}},"Detalle":[{"NroLinDet":"1","CdgItem":{"TpoCodigo":"INT1","VlrCodigo":"GAS05N"},"NmbItem":"Carga de gas 05 kg Normal","QtyItem":"7.000000","MontoItem":"1"},{"NroLinDet":"2","CdgItem":{"TpoCodigo":"INT1","VlrCodigo":"GAS11N"},"NmbItem":"Carga de gas 11 kg Normal","QtyItem":"3.000000","MontoItem":"1"},{"NroLinDet":"3","CdgItem":{"TpoCodigo":"INT1","VlrCodigo":"GAS15N"},"NmbItem":"Carga de gas 15 kg Normal","QtyItem":"325.000000","MontoItem":"1"}],"TED":{"@version":"1.0","DD":{"RE":"91806000-6","TD":"52","F":"2933959","FE":"2022-09-14","RR":"6492827-9","RSR":"IRIS DEL CARMEN FIGUEROA FIGUEROA","MNT":"1","IT1":"Carga de gas 05 kg Normal","CAF":{"@version":"1.0","DA":{"RE":"91806000-6","RS":"ABASTIBLE S.A.","TD":"52","RNG":{"D":"2924600","H":"2954599"},"FA":"2022-07-04","RSAPK":{"M":"w3J7b078/iLyg62E6OA4Rami2AK0ciPI6IAXj5YD7Mu7NgfdQKJVDFqDjVuPENyk4Ekoo4hsUBKvXOfiLZfyCw==","E":"Aw=="},"IDK":"300"},"FRMA":{"@algoritmo":"SHA1withRSA","#text":"P1nr+Al56ewpDpkDeGv/ipHCUCDNcVvAJoz8yKNQnyn/Nh9phA3ySVZz0MRXW/9tEDNFV4T1hudTlrYnKdN5dg=="}},"TSTED":"2022-09-14T11:24:26"},"FRMT":{"@algoritmo":"SHA1withRSA","#text":"D22eiMtKS88FKiL360nMeEGPHviY5Asy9BAzIBtE6BIiRkiJlWoz1xQRzMvfEJrCusSqllvT9w8zbkgB0TDORA=="}},"TmstFirma":"2022-09-14T11:25:06"},"tipoDTE":"52","folio":"2933959","userStatus":"PENDING","xmlGenerated":false,"autoApproved":false,"archived":false,"organisationID":"61f73517f61ed6ab6c8c3833"},"log":{"created_at":"2022-09-14T12:00:06.162000","created_by":"5fd1e1bb79c3e400079851fa"}}
  //    itemData = {"_id":"63177c95f0c766c4e3d2f059","data":{"encoding":"ISO-8859-1","document":{"@ID":"F4201643T61","Encabezado":{"IdDoc":{"TipoDTE":"61","Folio":"4201643","FchEmis":"2022-08-31","FmaPago":"1","FchVenc":"2022-08-31"},"Emisor":{"RUTEmisor":"91806000-6","RznSoc":"Abastible S.A.","GiroEmis":"Distribucion y transporte de combustibles, instalaciones de gas licuado","Acteco":"402000","Sucursal":"PLANIFICACIÓN COMERC","CdgSIISucur":"5098355","DirOrigen":"Av. Apoquindo N° 5550 Oficina 801-A","CmnaOrigen":"Las Condes","CiudadOrigen":"SANTIAGO","CdgVendedor":"916"},"Receptor":{"RUTRecep":"6492827-9","CdgIntRecep":"0010546793","RznSocRecep":"IRIS DEL CARMEN FIGUEROA FIGUEROA","GiroRecep":"VTA MEN GAS LIC BOM","Contacto":"dayanna_medina@hotmail.com","DirRecep":"HUAMACHUCO S/N","CmnaRecep":"SAN CLEMENTE"},"Transporte":{"DirDest":"HUAMACHUCO S/N","CmnaDest":"SAN CLEMENTE"},"Totales":{"MntNeto":"879010","MntExe":"0","TasaIVA":"19.00","IVA":"167012","MntTotal":"1046022"}},"Detalle":{"NroLinDet":"1","NmbItem":"APORTE POR FINANCIAMIENTO","QtyItem":"1.000000","PrcItem":"879010.000000","MontoItem":"879010"},"Referencia":{"NroLinRef":"1","TpoDocRef":"33","IndGlobal":"1","FolioRef":"0","FchRef":"2022-08-31","CodRef":"3","RazonRef":"Corrije monto"},"TED":{"@version":"1.0","DD":{"RE":"91806000-6","TD":"61","F":"4201643","FE":"2022-08-31","RR":"6492827-9","RSR":"IRIS DEL CARMEN FIGUEROA FIGUEROA","MNT":"1046022","IT1":"APORTE POR FINANCIAMIENTO","CAF":{"@version":"1.0","DA":{"RE":"91806000-6","RS":"ABASTIBLE S.A.","TD":"61","RNG":{"D":"4194910","H":"4209909"},"FA":"2022-08-08","RSAPK":{"M":"sMs5Cq5p1i6KqYvswTdP3Y1Hnm5m9+j9/NfcwYadIiBPNRXTUpTS+aIvkYuC86ffd0TmEXrNtWVmYBnS47aIYQ==","E":"Aw=="},"IDK":"300"},"FRMA":{"@algoritmo":"SHA1withRSA","#text":"nc9h+hbXvEh7fFMbQHHB3D8BenfcexLxduZjIYDtfqC1xn5br4tGMD80semqAzKQQ+ZKO1Q9z+eL9RNHT3OtAw=="}},"TSTED":"2022-09-06T12:36:05"},"FRMT":{"@algoritmo":"SHA1withRSA","#text":"hES0y+p+WLjavoutD5lzQB0KDquO7lfnel/hPPM9K51tArQAD7iIKmf3pQMbX+nOCRqkFNC4i84J6otP+aCzmw=="}},"TmstFirma":"2022-09-06T12:36:24"},"tipoDTE":"61","folio":"4201643","userStatus":"ACCEPTED","xmlGenerated":true,"autoApproved":true,"archived":false,"organisationID":"61f73517f61ed6ab6c8c3833"},"log":{"created_at":"2022-09-06T14:00:05.412000","created_by":"5fd1e1bb79c3e400079851fa","auto_approved_at":"2022-09-14T15:00:02.217000"}}
  //    itemData = {"_id":"63068344e53bb5170b08b7d9","data":{"encoding":"ISO-8859-1","document":{"@ID":"MiPE76976604-27740","Encabezado":{"IdDoc":{"TipoDTE":"34","Folio":"3162","FchEmis":"2022-08-22","TpoTranCompra":"1","TpoTranVenta":"1","FmaPago":"1"},"Emisor":{"RUTEmisor":"76976604-9","RznSoc":"CONTABILIDADES BERNARDA GONZALEZ GUTIERREZ SPA","GiroEmis":"ASESORIAS CONTABLES, TRIBUTARIAS,LABORALES","Telefono":"0 712232113","CorreoEmisor":"CONTABILIDADESBGG@GMAIL.COM","Acteco":"829900","CdgSIISucur":"082904788","DirOrigen":"2 SUR 795  31","CmnaOrigen":"TALCA","CiudadOrigen":"TALCA"},"Receptor":{"RUTRecep":"6492827-9","RznSocRecep":"IRIS DEL CARMEN FIGUEROA FIGUEROA","GiroRecep":"VENTA AL POR MENOR DE GAS LICUADO EN BOM","DirRecep":"HUAMACHUCO S/N.    SECTOR EL ALBA","CmnaRecep":"SAN CLEMENTE","CiudadRecep":"SAN CLEMENTE"},"Totales":{"MntExe":"98000","MntTotal":"98000"}},"Detalle":{"NroLinDet":"1","NmbItem":"SERVICIOS CONTABLES MES","DscItem":"DE JULIO 2022","QtyItem":"1.00","PrcItem":"98000.00","MontoItem":"98000"},"TED":{"@version":"1.0","DD":{"RE":"76976604-9","TD":"34","F":"3162","FE":"2022-08-22","RR":"6492827-9","RSR":"IRIS DEL CARMEN FIGUEROA FIGUEROA","MNT":"98000","IT1":"SERVICIOS CONTABLES MES","CAF":{"@version":"1.0","DA":{"RE":"76976604-9","RS":"CONTABILIDADES BERNARDA GONZALEZ GUTIERR","TD":"34","RNG":{"D":"3162","H":"3162"},"FA":"2022-08-24","RSAPK":{"M":"uyLB7bQwByfTV12ydWF9MQ+GFDbwHMqSMTIUvjw8xymz8MV/Qv9nTz9r7CEo+B/hM6bO+M/MpmAagxN/+lVrpQ==","E":"Aw=="},"IDK":"300"},"FRMA":{"@algoritmo":"SHA1withRSA","#text":"ScFQgu1AP8phjY+x3hc764GyYtzs3jnAs8e10OgBord6K3g93w/tbxEDZzZLCAObYd8yN2aHXxAnWOv9UVSqjQ=="}},"TSTED":"2022-08-24T15:45:18"},"FRMT":{"@algoritmo":"SHA1withRSA","#text":"iJO6iWmoWPYrvbTUqeC3Bzz1+5/ACNw665zwMiLlprC16Wtj3ruaMaJ7HhpDHnHP+sKmlhzHVuczgWt2fnLJTw=="}},"TmstFirma":"2022-08-24T15:45:18"},"tipoDTE":"34","folio":"3162","userStatus":"ACCEPTED","xmlGenerated":true,"autoApproved":true,"archived":false,"organisationID":"61f73517f61ed6ab6c8c3833"},"log":{"created_at":"2022-08-24T16:00:04.813000","created_by":"5fd1e1bb79c3e400079851fa","auto_approved_at":"2022-09-01T17:00:02.382000"}}
  const { itemData, barcodeImage, barcodeHeight, barcodeWidth } = props;
  console.log(
    '🚀 ~ file: PurchaseDocuments.js ~ line 111 ~ DocumentDetailsModal ~ itemData',
    itemData.data.document.Referencia
  );
  const generalText = {
    textAlign: 'center',
    fontSize: 14
  };
  const [titleName, setTitleName] = React.useState('');
  // const [barcodeImage, setBarcodeImage] = React.useState("")
  // let responseHeight;
  // let responseWidth;
  // let barcodeWidth = BARCODE_WIDTH;
  // let barcodeHeight = 0

  const componentRef = useRef();
  // let titleName = "";

  const formateNumber = value => {
    return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };
  const dicountNumberFormat = value => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };
  // const getBarcodeImage = () => {
  //     // https://webapi.ebol.cl/v1/api/barcode/intercambio_documents/6321ec76896138d392ef0974
  //    let statusCode;
  //     // fetch(`https://webapi.ebol.cl/v1/api/barcode/intercambio_documents/6321ec76896138d392ef0974`, {
  //     fetch(`${API_URL}barcode/intercambio_documents/6321ec76896138d392ef0974`, {
  //         method: "get",
  //         headers: {
  //               Accept: 'application/json',
  //               'Content-Type': 'application/json',
  //         },
  //         credentials: "include"
  //     })
  //         .then(response => {
  //             console.log("🚀 ~ file: PurchaseDocuments.js ~ line 129 ~ getBarcodeImage ~ response", response)
  //             // statusCode = res.status;
  //             // return res.json();
  //             if (Object.keys(response.headers).length > 0) {
  //                 responseHeight =
  //                   response.headers.map['barcode-image-height'];
  //                 responseWidth = response.headers.map['barcode-image-width'];
  //               } else {
  // responseHeight = BARCODE_HEIGHT;
  // responseWidth = BARCODE_WIDTH;
  //               }

  //               if (response.status === 404) {
  //                 return response.json();
  //               } else {
  //                 return response.text();
  //               }
  //         })
  //         .then(result => {
  //             console.log("purchase documents details barode api response...", result);
  //                  if (result.message) {
  //                  console.log("🚀 ~ file: PurchaseDocuments.js ~ line 151 ~ getBarcodeImage ~ result", result.message)
  //                 // this.setState({
  //                 //   visible: true,
  //                 //   message: result.message,
  //                 // });
  //               } else {
  //                 barcodeHeight =
  //                   (barcodeWidth * responseWidth) / responseHeight;

  //                 barcodeHeight = Math.round(barcodeHeight);

  //                 setBarcodeImage(result);
  //               }
  //         })
  //         .catch(err => {
  //             console.log("purchase documents details api error...", err);
  //         });
  // }
  React.useEffect(() => {
    writtenNumber.defaults.lang = 'es';
    if (itemData !== null || itemData !== undefined) {
      if (itemData.data.tipoDTE === '33') {
        setTitleName('FACTURA ELECTRÓNICA');
      } else if (itemData.data.tipoDTE === '34') {
        setTitleName('FACTURA NO AFECTA O EXENTA ELECTRÓNICA');
      } else if (itemData.data.tipoDTE === '39') {
        setTitleName('BOLETA ELECTRÓNICA');
      } else if (itemData.data.tipoDTE === '41') {
        setTitleName('BOLETA NO AFECTA O EXENTA ELECTRÓNICA');
      } else if (itemData.data.tipoDTE === '52') {
        setTitleName('GUIA DE DESPACHO ELECTRÓNICA');
        //   setTitleName("NOTA DE CRÉDITO")
      } else if (itemData.data.tipoDTE === '56') {
        setTitleName('NOTA DE DÉBITO ELECTRÓNICA');
      } else if (itemData.data.tipoDTE === '61') {
        setTitleName('NOTA DE CRÉDITO ELECTRÓNICA');
      }
    } else {
      setTitleName('');
    }
  }, []);

  const getReferenceValue = (value) => {
    // value = 34
    let data = tipoDocValues.find(item => {
      if (item.tipoDoc == value) {
        // return item.value
        console.log('in if block')
        return item.value;
      } else {
        console.log('in else block');
        return null
      }
    })
    return data !== "" && data !== undefined && data !== null ? data.value : ""
  }
  return (
    <Modal
      {...props}
      size="small"
      aria-labelledby="contained-modal-title-vcenter"
      fullscreen={true}
    >
      <Modal.Header closeButton>
        {/* <Modal.Title id="contained-modal-title-vcenter">
                    Modal heading
                </Modal.Title> */}
      </Modal.Header>
      <Modal.Body>
        {itemData.data !== undefined && (
          <>
            <div
              ref={componentRef}
              className="print-invoice"
              style={{
                backgroundColor: '#fff',
                width: '100%',
                borderColor: '#999999',
                borderWidth: 1,
                padding: 20
              }}
            >
              <p style={generalText}>
                R.U.T. :{'  '}
                {itemData.data.document.Encabezado.Emisor.RUTEmisor}
              </p>
              <p style={generalText}>
                {/* FACTURA ELECTRÓNICA NO. */}
                {titleName}
                {/* {titleName} NO.{"  "}
                            {itemData.data.folio} */}
              </p>
              <p style={generalText}>
                {/* FACTURA ELECTRÓNICA NO. */}
                NO.{'  '}
                {itemData.data.folio}
              </p>
              {/* <p style={generalText}>
                            Fecha :{'               '}
                            {
                               moment(itemData.data.document.Encabezado.IdDoc.FchEmis).format('DD/MM/YYYY')
                            } */}
              {/* {new Date(
                                itemData.data.document.Encabezado.IdDoc.FchEmis,
                            ).toLocaleDateString()} */}
              {/* </p> */}
              <p style={{ marginTop: 10 }}>
                <p
                  style={{
                    textAlign: 'center',
                    fontSize: 15,
                    opacity: 0.7
                  }}
                >
                  ----------------------------------------------
                </p>
              </p>

              <p style={{ fontSize: 14 }}>
                {itemData.data.document.Encabezado.Emisor.RznSoc}
              </p>
              <p style={{ fontSize: 14 }}>
                {itemData.data.document.Encabezado.Emisor.DirOrigen}
              </p>
              <p style={{ fontSize: 14 }}>
                {itemData.data.document.Encabezado.Emisor.CmnaOrigen},{' '}
                {itemData.data.document.Encabezado.Emisor.CiudadOrigen}
              </p>
              <p style={{ fontSize: 14 }}>
                GIRO : {itemData.data.document.Encabezado.Emisor.GiroEmis}
              </p>
              <p style={{ marginTop: 10 }}>
                <p
                  style={{
                    textAlign: 'center',
                    fontSize: 15,
                    opacity: 0.7
                  }}
                >
                  ----------------------------------------------
                </p>
              </p>

              <p style={{ fontSize: 14 }}>
                RUT : {itemData.data.document.Encabezado.Receptor.RUTRecep}
              </p>
              <p style={{ fontSize: 14 }}>
                Nombre :{' '}
                {itemData.data.document.Encabezado.Receptor.RznSocRecep}
              </p>
              <p style={{ fontSize: 14 }}>
                DIRECCION :{' '}
                {itemData.data.document.Encabezado.Receptor.DirRecep}
              </p>
              <p style={{ fontSize: 14 }}>
                {itemData.data.document.Encabezado.Receptor.CmnaRecep}
              </p>
              <p style={{ fontSize: 14 }}>
                {itemData.data.document.Encabezado.Receptor.CiudadRecep}
              </p>

              <p style={{ fontSize: 14 }}>
                GIRO : {itemData.data.document.Encabezado.Receptor.GiroRecep}
              </p>
              <p style={{ fontSize: 14 }}>
                Nombre de contacto :{' '}
                {itemData.data.document.Encabezado.Receptor.RznSocRecep}
              </p>
              {itemData.data.document.Referencia !== undefined &&
                itemData.data.document.Referencia !== null ? (
                Array.isArray(itemData.data.document.Referencia)
                  ? null
                  : itemData.data.document.Referencia.FolioRef !== undefined
                  && itemData.data.document.Referencia.FolioRef !== null
                  && itemData.data.document.Referencia.FolioRef != 0
                  && itemData.data.document.Referencia.RazonRef !== null
                  && itemData.data.document.Referencia.RazonRef !== undefined
                  && <p style={{ fontSize: 14 }}>
                    Referencias:{' '}
                    {itemData.data.document.Referencia.RazonRef !== null
                      && itemData.data.document.Referencia.RazonRef !== undefined
                      ? itemData.data.document.Referencia.RazonRef : ''
                    }{' '}
                    {
                      getReferenceValue(itemData.data.document.Referencia.TpoDocRef)
                    }{' '}
                    Electrónica {itemData.data.document.Referencia.FolioRef}
                  </p>
              ) : null}
              <p style={{ textAlign: 'left', fontSize: 14, marginTop: 10 }}>
                Fecha :{'               '}
                {moment(itemData.data.document.Encabezado.IdDoc.FchEmis).format(
                  'DD/MM/YYYY'
                )}
                {/* {new Date(
                                itemData.data.document.Encabezado.IdDoc.FchEmis,
                            ).toLocaleDateString()} */}
              </p>
              {/* <p style={{ marginTop: 10 }}>
                        </p> */}
              <p
                style={{
                  textAlign: 'center',
                  fontSize: 15,
                  opacity: 0.7
                }}
              >
                ----------------------------------------------
              </p>

              {Array.isArray(itemData.data.document.Detalle) ? (
                <>
                  {itemData.data.document.Detalle.map(item => {
                    console.log(
                      'in map method of if condition',
                      parseInt(item.QtyItem) * parseInt(item.MontoItem)
                    );
                    return (
                      <>
                        <p style={{ fontSize: 14 }}>{item.NmbItem}</p>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <p style={{ fontSize: 14 }}>
                            {/* Here the item quantity type we receives Like UN,KG,GRM,LTR etc... */}
                            {item.QtyItem ? parseInt(item.QtyItem) : 1}{' '}
                            {/* {item.UnmdItem === 'UN'
                                                        ? parseInt(item.QtyItem)
                                                        : parseFloat(item.QtyItem)}{' '} */}
                            X{' '}
                            {item.PrcItem !== undefined
                              ? formateNumber(parseInt(item.PrcItem))
                              : formateNumber(parseInt(item.MontoItem))}
                          </p>
                          <p style={{ marginLeft: 'auto', fontSize: 14 }}>
                            {/* {item.PrcItem !== undefined 
                                                     ? item.MontoItem.replace(
                                                        /\B(?=(\d{3})+(?!\d))/g,
                                                        '.',
                                                    )
                                                     : parseInt(item.QtyItem)*parseInt(item.MontoItem).toString().replace(
                                                        /\B(?=(\d{3})+(?!\d))/g,
                                                        '.',
                                                    )
                                                    } */}
                            {item.MontoItem.replace(
                              /\B(?=(\d{3})+(?!\d))/g,
                              '.'
                            )}
                          </p>
                        </div>
                      </>
                    );
                  })}
                </>
              ) : (
                <>
                  <p style={{ fontSize: 14 }}>
                    {itemData.data.document.Detalle.NmbItem}
                  </p>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <p style={{ fontSize: 14 }}>
                      {/* Here the item quantity type we receives Like UN,KG,GRM,LTR etc... */}
                      {typeof itemData.data.document.Detalle.QtyItem !==
                        'undefined' && itemData.data.document.Detalle.QtyItem
                        ? // .UnmdItem === 'UN'
                        parseInt(itemData.data.document.Detalle.QtyItem)
                        : 1}{' '}
                      X{' '}
                      {formateNumber(
                        typeof itemData.data.document.Detalle.PrcItem !==
                          'undefined'
                          ? parseInt(itemData.data.document.Detalle.PrcItem)
                          : typeof itemData.data.document.Detalle.MontoItem !==
                            'undefined'
                            ? parseInt(itemData.data.document.Detalle.MontoItem)
                            : 1
                      )}
                    </p>
                    <p style={{ marginLeft: 'auto', fontSize: 14 }}>
                      {itemData.data.document.Detalle.MontoItem.replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        '.'
                      )}
                    </p>
                  </div>
                </>
              )}

              <p style={{ marginTop: 20 }}></p>
              {itemData.data.document.DscRcgGlobal !== undefined && (
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    marginLeft: '20%'
                  }}
                >
                  <p style={{ fontSize: 14, textAlign: 'left', width: 300 }}>
                    DESCUENTO
                  </p>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%'
                    }}
                  >
                    {itemData.data.document.DscRcgGlobal.map(item => {
                      return (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%'
                          }}
                        >
                          <p style={{ fontSize: 14, marginLeft: 20 }}>
                            {' '}
                            {'  '}$
                          </p>
                          <p style={{ fontSize: 14, marginLeft: 'auto' }}>
                            {item.ValorDR !== undefined
                              ? dicountNumberFormat(parseInt(item.ValorDR))
                              : // .replace(
                              //         /\B(?=(\d{3})+(?!\d))/g,
                              //         '.',
                              //     )
                              0}
                          </p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {/* {itemData.data.document.Encabezado.Totales.MntNeto !== undefined && */}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: '20%'
                }}
              >
                <p style={{ fontSize: 14, textAlign: 'left', width: 300 }}>
                  {/* NETO */}
                  AFECTO
                </p>
                {/* <p style={{ fontSize: 14, marginLeft: 20 }}> {'  '}$</p> */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%'
                  }}
                >
                  {/* <p style={{ fontSize: 14 }}> {'  '}$</p> */}
                  <p style={{ fontSize: 14, marginLeft: 20 }}> {'  '}$</p>

                  <p style={{ fontSize: 14, marginLeft: 'auto' }}>
                    {/* {itemData.data.document.Encabezado.Totales.MntNeto !== undefined &&} */}
                    {itemData.data.document.Encabezado.Totales.MntNeto !==
                      undefined
                      ? itemData.data.document.Encabezado.Totales.MntNeto.replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        '.'
                      )
                      : 0}
                    {/* {itemData.data.document.Encabezado.Totales.MntNeto.replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        '.',
                                    )} */}
                  </p>
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: '20%'
                }}
              >
                <p style={{ fontSize: 14, textAlign: 'left', width: 300 }}>
                  TOTAL IVA (19 %)
                </p>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%'
                  }}
                >
                  <p style={{ fontSize: 14, marginLeft: 20 }}> {'  '}$</p>
                  {/* <p style={{ fontSize: 14 }}> {'  '}$</p> */}
                  <p style={{ fontSize: 14, marginLeft: 'auto' }}>
                    {/* {itemData.data.document.Encabezado.Totales.IVA !== undefined &&} */}
                    {itemData.data.document.Encabezado.Totales.IVA !== undefined
                      ? itemData.data.document.Encabezado.Totales.IVA.replace(
                        /\B(?=(\d{3})+(?!\d))/g,
                        '.'
                      )
                      : 0}
                    {/* {itemData.data.document.Encabezado.Totales.IVA.replace(
                                        /\B(?=(\d{3})+(?!\d))/g,
                                        '.',
                                    )} */}
                  </p>
                </div>
              </div>

              {itemData.data.document.Encabezado.Totales.ImptoReten !==
                undefined && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginLeft: '20%'
                    }}
                  >
                    <p style={{ fontSize: 14, textAlign: 'left', width: 300 }}>
                      {/* IMPUESTO ADICIONAL */}
                      OTROS IMPUESTOS
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%'
                      }}
                    >
                      <p style={{ fontSize: 14, marginLeft: 20 }}> {'  '}$</p>
                      <p style={{ fontSize: 14, marginLeft: 'auto' }}>
                        {itemData.data.document.Encabezado.Totales.ImptoReten
                          .MontoImp !== undefined
                          ? itemData.data.document.Encabezado.Totales.ImptoReten.MontoImp.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            '.'
                          )
                          : 0}
                      </p>
                    </div>
                  </div>
                )}

              {itemData.data.document.Encabezado.Totales.MntExe !==
                undefined && (
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginLeft: '20%'
                    }}
                  >
                    <p style={{ fontSize: 14, textAlign: 'left', width: 300 }}>
                      EXENTO
                    </p>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        width: '100%'
                      }}
                    >
                      <p style={{ fontSize: 14, marginLeft: 20 }}> {'  '}$</p>
                      <p style={{ fontSize: 14, marginLeft: 'auto' }}>
                        {itemData.data.document.Encabezado.Totales.MntExe !==
                          undefined
                          ? itemData.data.document.Encabezado.Totales.MntExe.replace(
                            /\B(?=(\d{3})+(?!\d))/g,
                            '.'
                          )
                          : 0}
                      </p>
                    </div>
                  </div>
                )}

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: '20%'
                }}
              >
                <p style={{ fontSize: 14, textAlign: 'left', width: 300 }}>
                  TOTAL
                </p>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%'
                  }}
                >
                  <p style={{ fontSize: 14, marginLeft: 20 }}> {'  '}$</p>

                  {/* <p style={{ fontSize: 14 }}> {'  '}$</p> */}
                  <p style={{ fontSize: 14, marginLeft: 'auto' }}>
                    {itemData.data.document.Encabezado.Totales.MntTotal.replace(
                      /\B(?=(\d{3})+(?!\d))/g,
                      '.'
                    )}
                  </p>
                </div>
              </div>

              <p style={{ marginTop: 10 }}></p>
              <p style={{ textAlign: 'left' }}>
                son :{' '}
                {writtenNumber(
                  itemData.data.document.Encabezado.Totales.MntTotal
                )}
              </p>
              <p style={{ marginTop: 10 }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: 'auto'
                  }}
                >
                  {barcodeImage && (
                    <img
                      src={`data:image/jpeg;base64,${barcodeImage}`}
                      style={{
                        height: barcodeHeight,
                        width: barcodeWidth
                        // height: 291,
                        // width: 300
                      }}
                    />
                  )}
                </div>
              </p>
              <p style={generalText}>Timbre Electrónico SII RES. 115 DE 2005</p>
              <p style={generalText}>www.ebol.cl</p>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        {/* <Button onClick={props.onHide}>Close</Button> */}
        <div className="w-100 d-flex justify-content-between">
          <ReactToPrint
            trigger={() => (
              <Button
                pill
                size="lg"
                className="mt-4 mr-2"
                style={{
                  width: '40%',
                  alignSelf: 'center'
                }}
              >
                {' '}
                {strings.print}
              </Button>
            )}
            content={() => componentRef.current}
          />
          <Button
            pill
            size="lg"
            className="mt-4 mr-2"
            style={{
              width: '40%',
              alignSelf: 'center'
            }}
            onClick={props.onHide}
          >
            Close
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

let today = new Date();
let dd = String(today.getDate()).padStart(2, '0');
let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
let yyyy = today.getFullYear();

let start_date = '01' + '/' + mm + '/' + yyyy;
let end_date = dd + '/' + mm + '/' + yyyy;

let intitalStartDateApi = yyyy + '-' + mm + '-' + '01';
let intialEndDateApi = yyyy + '-' + mm + '-' + dd;

const PurchaseDocuments = () => {
  const [documentType, setDocumentType] = React.useState('PENDING');
  const [records, setRecords] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = React.useState('');
  const [page, setPage] = React.useState(1);
  const [prev, setPrev] = React.useState(true);
  const [next, setNext] = React.useState(false);
  const [isListCompleted, setIsListCompleted] = React.useState(false);
  const [confirmationModalShow, setConfirmationModalShow] = React.useState(
    false
  );
  const [detailsModalShow, setDetailsModalShow] = React.useState(false);
  const [accepted, setAccepted] = React.useState(0);
  const [rejected, setRejected] = React.useState(0);
  const [itemData, setItemData] = React.useState({});
  const [barcodeImage, setBarcodeImage] = React.useState('');
  const [isProceedButtonDesabled, setIsProceedButtonDesabled] = React.useState(
    true
  );
  const [locale, setLocale] = React.useState({ format: 'DD/MM/YYYY' });
  const [startDate, setStartDate] = React.useState(start_date);
  console.log(
    '🚀 ~ file: PurchaseDocuments.js ~ line 584 ~ PurchaseDocuments ~ startDate',
    startDate
  );
  const [endDate, setEndDate] = React.useState(end_date);
  console.log(
    '🚀 ~ file: PurchaseDocuments.js ~ line 586 ~ PurchaseDocuments ~ endDate',
    endDate
  );
  const [startDateApi, setStartDateApi] = React.useState(intitalStartDateApi);
  console.log(
    '🚀 ~ file: PurchaseDocuments.js ~ line 588 ~ PurchaseDocuments ~ startDateApi',
    startDateApi
  );
  const [endDateApi, setEndDateApi] = React.useState(intialEndDateApi);
  console.log(
    '🚀 ~ file: PurchaseDocuments.js ~ line 590 ~ PurchaseDocuments ~ endDateApi',
    endDateApi
  );
  const [barcodeHeight, setBarcodeHeight] = useState('');
  const months = {
    Jan: '01',
    Feb: '02',
    Mar: '03',
    Apr: '04',
    May: '05',
    Jun: '06',
    Jul: '07',
    Aug: '08',
    Sep: '09',
    Oct: '10',
    Nov: '11',
    Dec: '12'
  };
  // startDate: start_date,
  // endDate: end_date,
  // startDateApi: startDateApi,
  // endDateApi: endDateApi,

  let responseHeight;
  let responseWidth;
  let barcodeWidth = BARCODE_WIDTH;
  const userStatusInfo = [];
  const columns = [
    {
      key: 'rutNumber',
      text: 'Rut Emisor'
    },
    {
      key: 'emisorName',
      text: 'Nombre o razón social'
    },
    {
      key: 'documentType',
      text: 'Tipo de Documento'
    },
    {
      key: 'folio',
      text: 'Folio'
    },
    {
      key: 'userStatus',
      text: 'Estado'
    },
    {
      key: 'issueDate',
      text: 'Fecha'
    },
    // {
    //     key: "leftDays",
    //     text: "Days Left To Accept"
    // },
    {
      key: 'totalAmount',
      text: 'Total'
    },
    {
      key: '_id',
      text: 'Acción',
      className: 'action',
      cell: (record, index) => {
        return (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            {record.userStatus === 'ACCEPTED' && (
              <div
                style={{
                  height: 25,
                  width: 50,
                  backgroundColor: '#00e676',
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  boxShadow: '5px 10px 18px #888888'
                }}
              >
                <i class="material-icons" style={{ fontSize: 20 }}>
                  done
                </i>
              </div>
            )}
            {record.userStatus === 'REJECTED' && (
              <div
                style={{
                  height: 25,
                  width: 50,
                  backgroundColor: '#ff1744',
                  display: 'flex',
                  justifyContent: 'center',
                  alignContent: 'center',
                  boxShadow: '5px 10px 18px #888888',
                  borderLeft: '1px solid black'
                }}
              >
                <i class="material-icons" style={{ fontSize: 20 }}>
                  close
                </i>
              </div>
            )}
            {record.userStatus === 'PENDING' && (
              <UserStatus
                record={record}
                ref={ref => userSatusRefArray(index, ref)}
              />
            )}
            {/* <p style={{ marginTop: 12, fontSize: 14, textDecorationLine: 'underline' }}
                            onClick={() => {
                                fetchDtailsData(record._id)
                                // setDetailsModalShow(true)
                            }}
                        >Details</p> */}
            <div
              style={{
                height: 25,
                width: 50,
                backgroundColor: '#fff',
                display: 'flex',
                justifyContent: 'center',
                alignContent: 'center',
                boxShadow: '5px 10px 18px #888888',
                marginLeft: 15
              }}
              onClick={() => {
                fetchDtailsData(record._id);
                // setDetailsModalShow(true)
              }}
            >
              <i class="material-icons" style={{ fontSize: 20 }}>
                visibility
              </i>
            </div>
          </div>
        );
      }
    }
  ];
  const config = {
    page_size: 10,
    show_length_menu: false,
    show_info: false,
    show_pagination: false,
    button: {
      excel: false,
      print: false,
      extra: false
    }
  };

  const userSatusRefArray = (index, item) => {
    if (item) {
      userStatusInfo[index] = item.userStatusList();
    }
    console.log('userStatusInfo.......', userStatusInfo);
    let result = userStatusInfo.filter(item => item.userStatus !== 'PENDING');
    if (result.length > 0) {
      setIsProceedButtonDesabled(false);
    } else {
      setIsProceedButtonDesabled(true);
    }
  };

  const fetchData = (
    startDateParam = startDateApi,
    endDateApiParam = endDateApi
  ) => {
    setLoading(true);
    let statusCode = '';
    console.log(
      `${API_URL}purchase-documents?type=${documentType}&q=${search}&page=${page}&dateFrom=${startDateParam}&dateTo=${endDateApiParam}`
    );
    fetch(
      `${API_URL}purchase-documents?type=${documentType}&q=${search}&page=${page}&dateFrom=${startDateParam}&dateTo=${endDateApiParam}`,
      {
        method: 'GET',
        credentials: 'include'
      }
    )
      .then(res => {
        statusCode = res.status;
        return res.json();
      })
      .then(res => {
        console.log('purchase documents list api response...', res);
        setLoading(false);
        if (statusCode === 200) {
          setRecords(res.data);
          if (res.data.length == 0) {
            setIsListCompleted(true);
          }
        }
      })
      .catch(err => {
        console.log('purchase documents list api error...', err);
        setLoading(false);
      });
  };
  const fetchDtailsData = id => {
    let statusCode = '';
    console.log(`${API_URL}purchase-documents?id=${id}`);
    fetch(`${API_URL}purchase-documents?id=${id}`, {
      method: 'GET',
      credentials: 'include'
    })
      .then(res => {
        statusCode = res.status;
        return res.json();
      })
      .then(res => {
        console.log('purchase documents details api response...', res);
        if (statusCode === 200) {
          setItemData(res);
          fetch(`${API_URL}barcode/intercambio_documents/${id}?responseType=json`, {
            method: 'get',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            credentials: 'include'
          })
            .then(response => {
              console.log(
                '🚀 ~ file: PurchaseDocuments.js ~ line 129 ~ getBarcodeImage ~ response',
                response
              );
              // statusCode = res.status;
              // return res.json();
              return response.json();
            })
            .then(result => {
              console.log(
                'purchase documents details barode api response...',
                result
              );
              if (result.message) {
                console.log(
                  '🚀 ~ file: PurchaseDocuments.js ~ line 151 ~ getBarcodeImage ~ result',
                  result.message
                );
                // this.setState({
                //   visible: true,
                //   message: result.message,
                // });
              } else {
                const data = getBarcodeValuesFromResponse(result);
                console.log('data', data);
                responseHeight = data.responseHeight;
                responseWidth = data.responseWidth;
                // barcodeHeight = (barcodeWidth * responseWidth) / responseHeight;
                // barcodeHeight = Math.round(barcodeHeight);
                let barcodeHeight = getBarcodeImageHeight(barcodeWidth, data.responseHeight, data.responseWidth);
                console.log('barcodeHeight', barcodeHeight);
                setBarcodeImage(data.barcodeImage);
                setDetailsModalShow(true);
                setBarcodeHeight(barcodeHeight);
              }
            })
            .catch(err => {
              console.log('purchase documents details api error...', err);
            });
        }
      })
      .catch(err => {
        console.log('purchase documents details api error...', err);
      });
  };
  console.log('barcodeImage', barcodeImage);
  console.log('detailModalShow', detailsModalShow);
  console.log('barcodeHeight outside', barcodeHeight);

  const onConfirmation = async () => {
    let result = userStatusInfo.filter(item => item.userStatus !== 'PENDING');
    console.log('========================userStatusInfo', result);
    let statusCode = '';
    let data = JSON.stringify(result);
    fetch(`${API_URL}purchase-documents`, {
      method: 'put',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: data
    })
      .then(res => {
        statusCode = res.status;
        return res.json();
      })
      .then(res => {
        console.log('api response on confirmation yes button click', res);
        if (statusCode === 200) {
          setRecords([]);
          setDocumentType('PENDING');
          setConfirmationModalShow(false);
          fetchData();
        }
      })
      .catch(err => {
        console.log('api error on confirmation yes button click', err);
      });
  };

  const handleChange = e => {
    setDocumentType(e.target.value);
    setIsListCompleted(false);
    setRecords([]);
  };

  React.useEffect(() => {
    fetchData();
  }, [documentType, page]);
  const pageIncrement = () => {
    if (!isListCompleted) {
      setPrev(false);
      setPage(page + 1);
    } else {
      setNext(true);
      setPrev(false);
    }
  };
  const pageDecrement = () => {
    if (page > 1) {
      setPage(page - 1);
      setNext(false);
    } else {
      setPrev(true);
      setNext(false);
    }
  };
  console.log('page....', page);

  const handleCallback = (start, end) => {
    var startDate = new Date(start);
    console.log(`startDate is ${startDate} `);
    let formatStartDate = startDate.toDateString().split(' ');
    let startDateMonth = months[formatStartDate[1]];
    let startDateApi =
      formatStartDate[3] + '-' + startDateMonth + '-' + formatStartDate[2];
    console.log(
      '🚀 ~ file: index.js ~ line 532 ~ Customers ~ startDateApi1',
      startDateApi
    );

    // var startDateApi = startDate.setDate(startDate.getDate() + 1);
    // startDateApi = startDate.toISOString().slice(0, 10);
    var endDate = new Date(end);
    console.log(
      '🚀 ~ file: index.js ~ line 550 ~ Customers ~ endDate',
      endDate
    );
    // var endDateApi = endDate.toISOString().slice(0, 10);

    let formatEndDate = endDate.toDateString().split(' ');
    let endDateMonth = months[formatEndDate[1]];
    let endDateApi =
      formatEndDate[3] + '-' + endDateMonth + '-' + formatEndDate[2];

    // var endDateApi = endDate.toDateString();

    // let startDateApi1 =  moment(startDate).format('YYYY/DD/MM')
    // let endDateApi1 =  moment(endDate).format('YYYY/DD/MM')
    // console.log(`startDateApi1 is ${startDateApi1} and endDateApi1 is ${endDateApi1}`)

    console.log(
      `var startDateApi = ${startDateApi} and endDateApi = ${endDateApi}`
    );
    setStartDateApi(startDateApi);
    setEndDateApi(endDateApi);
    setStartDate(start);
    setEndDate(end);
    fetchData(startDateApi, endDateApi);
  };

  return (
    <>
      <Container
        fluid
        className="main-content-container px-4"
        style={{ marginBottom: '200px' }}
      >
        <Row noGutters className="page-header py-4">
          <PageTitle
            title="Documentos de compra"
            className="text-sm-left mb-3"
          />
        </Row>

        <Row>
          <Col lg="3" md="12" sm="12">
            <Card small className="mb-4 p-4">
              <div className="row">
                <Col>
                  <FormInput
                    type="text"
                    value={search}
                    // placeholder="Busca aquí"
                    placeholder="Busca aqui, escribe el nombre o la razon social"
                    onChange={e => setSearch(e.target.value)}
                    onKeyPress={event => {
                      if (event.key === 'Enter') {
                        fetchData();
                      }
                    }}
                  />
                </Col>
              </div>
            </Card>
          </Col>
          <Col lg="3" md="12" sm="12">
            <Card small className="mb-4 p-4">
              <div className="row">
                <select
                  value={documentType}
                  className="form-control"
                  onChange={e => handleChange(e)}
                >
                  <option value="PENDING">Pendiente</option>
                  <option value="ACCEPTED">Aceptado</option>
                  <option value="REJECTED">Reclamado</option>
                  <option value="">Todos los documentos</option>
                </select>
              </div>
            </Card>
          </Col>
          <Col lg="3" md="12" sm="12">
            <Card small className="mb-4 p-4">
              <div className="row">
                <DateRangePicker
                  initialSettings={{
                    startDate: startDate,
                    endDate: endDate,
                    locale: locale
                  }}
                  // onEvent={this.handleEvent}
                  onApply={(event, picker) => {
                    console.log(
                      `picker startDate is ${picker.startDate} and endDate is ${picker.endDate}`
                    );
                    console.log(picker.endDate);
                    picker.element.val(
                      picker.startDate.format('DD/MM/YYYY') +
                      ' - ' +
                      picker.endDate.format('DD/MM/YYYY')
                    );
                  }}
                  onCallback={(start, end) => handleCallback(start, end)}
                  locale={locale}
                >
                  <input type="text" className="form-control" />
                </DateRangePicker>
              </div>
            </Card>
          </Col>
          <Col lg="3" md="12" sm="12">
            <div className="mb-4 p-4">
              <div className="row">
                <Button
                  theme="primary"
                  className="mb-2 mt-1"
                  disabled={isProceedButtonDesabled}
                  style={{ width: '40%' }}
                  onClick={() => {
                    setAccepted(0);
                    setRejected(0);
                    let result = userStatusInfo.filter(
                      item => item.userStatus !== 'PENDING'
                    );
                    let acceptedCount = 0;
                    let rejectedCount = 0;
                    result.map(item => {
                      console.log(item);
                      if (item.userStatus === 'ACCEPT') {
                        acceptedCount = acceptedCount + 1;
                      }
                      if (item.userStatus === 'REJECT') {
                        rejectedCount = rejectedCount + 1;
                      }
                    });
                    setAccepted(acceptedCount);
                    setRejected(rejectedCount);
                    setConfirmationModalShow(true);
                  }}
                >
                  Continuar
                </Button>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card small className="mb-4">
              <CardBody className="p-3 pb-3">
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <Loader
                    type="Puff"
                    color="#00BFFF"
                    height={100}
                    width={100}
                    visible={loading}
                  />
                </div>
                <div className="MainDiv">
                  <div className="table-responsive">
                    {!loading && (
                      <>
                        <ReactDatatable
                          config={config}
                          records={records}
                          columns={columns}
                          loading={loading}
                        />
                        <nav className="d-flex justify-content-center align-items-center">
                          <ul className="pagination">
                            <li className="page-item">
                              <a
                                className="page-link"
                                href="javascript:;"
                                onClick={() => {
                                  pageDecrement();
                                }}
                                style={
                                  prev
                                    ? { cursor: 'not-allowed', color: 'gray' }
                                    : null
                                }
                              >
                                Previous
                              </a>
                            </li>
                            <li className="page-item">
                              <a
                                className="page-link"
                                href="javascript:;"
                                onClick={() => {
                                  pageIncrement();
                                }}
                                style={
                                  next
                                    ? { cursor: 'not-allowed', color: 'gray' }
                                    : null
                                }
                              >
                                Next
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </>
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <ConfirmationModal
        show={confirmationModalShow}
        onHide={() => setConfirmationModalShow(false)}
        accepted={accepted}
        rejected={rejected}
        onConfirmation={onConfirmation}
      />
      {/* {detailsModalShow && ( */}
      {detailsModalShow && barcodeImage !== "" && (
        <DocumentDetailsModal
          show={detailsModalShow}
          itemData={itemData}
          barcodeImage={barcodeImage}
          barcodeWidth={barcodeWidth}
          barcodeHeight={barcodeHeight}
          onHide={() => setDetailsModalShow(false)}
        />
      )}
    </>
  );
};

export default PurchaseDocuments;
